import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/ProductSearch';
import './ProductSearch.css';
import { ControlLabel, FormControl, FormGroup, Form, HelpBlock, InputGroup, Button } from 'react-bootstrap';
import { ProductBoxes } from './ProductBoxes';
import InfiniteScroll from 'react-infinite-scroller';
import { RingLoader } from 'react-spinners';

import fetchClient from '../../components/common/FetchClient';
import { authContext } from '../../adalConfig';

//const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

class ProductSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            skip: 0,
            nextHref: null,
            products: [],
            hasMoreItems: false,
            hasSearched: false,
            foundItems: false,
            displayLoader: false,
            mobileView: window.innerWidth <= 1254 && window.innerWidth >= 768,
        };

        this.clearLastSearchAndItems = this.clearLastSearchAndItems.bind(this);
        this.changeKeywords = this.changeKeywords.bind(this);
        this.loadItems = this.loadItems.bind(this);
        this.selectFocus = this.selectFocus.bind(this);
    }

    componentDidMount() {
        if (!localStorage.getItem('customer')) {
            window.open('/customer-search', '_self');
        }

        window.addEventListener("resize", this.resize.bind(this));
        this.resize(true);

        const keywords = this.props.keywords || '';
        this.props.history.push('/product-search/' + keywords);
        if (keywords.length >= 3) {
            console.log('searching products from here...');
            this.loadItems();
        }
    }

    selectFocus(e) {
        e.target.select();
    }

    resize(skip) {
        // We only want to resize if the width changes so the Android 
        // keyboard doesn't disappear on inputs from the vertical height change
        if (window.innerWidth !== this.state.windowWidth || skip === true) {
            this.setState({ mobileView: window.innerWidth < 768 }, this.setState({ tabletView: window.innerWidth <= 1254 && window.innerWidth >= 768 }));
            this.setState({ wideView: window.innerWidth >= 1580 })
            this.setState({ windowWidth: window.innerWidth });
        }
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    changeKeywords(e) {
        this.props.setKeywords(e.target.value);
    }

    loadItems() {
        var self = this;
        if (self.props.keywords === '' || self.state.hasMoreItems === false || self.props.keywords === undefined) {
            return;
        }

        localStorage.setItem('lastItemSearch', self.props.keywords);

        var url = `api/Products/Search`;
        if (this.state.nextHref) {
            url = this.state.nextHref;
            console.log(url);
        }

        console.log('skip:', self.state.skip);

        fetchClient(url, {
            params: {
                keywords: self.props.keywords,
                skip: self.state.skip,
                custAccount: localStorage.getItem('customer'),
                addressId: localStorage.getItem('address'),
                employeeId: authContext.getCachedUser().userName.replace("@empirepaper.com", '')
            }
        }).then(function (resp) {
            self.setState((state, props) => {
                return { skip: state.skip + 20 };
            });

            var products = self.state.products;

            console.log(products);

            if (resp) {
                console.log(resp);

                var count = resp.data.length;

                if (count === 0) {
                    self.setState({
                        hasMoreItems: false
                    });
                    self.setState({
                        displayLoader: false
                    });
                    return;
                }

                self.setState({ foundItems: true });

                resp.data.map((product) => {
                    products.push(product);
                    return '';
                });

                if (self.state.skip !== 0 && self.state.products !== []) {
                    return;
                }

                self.setState({ products: products });

                console.log('adding products', self.state.products);
            }
        });
    }

    handleKeyDown(e) {
        if (e.keyCode === ENTER_KEY) {
            e.preventDefault();

            this.setState({ products: [], skip: 0 });

            if (e.target.value.length >= 3) {
                this.setState({ displayLoader: true });
                this.setState({ foundItems: false });

                this.props.history.push('/product-search/' + e.target.value);

                this.props.setKeywords(e.target.value);
                
                this.loadItems();

                this.setState({ hasSearched: true });
                
                this.setState({ hasMoreItems: true });
            }
        }
    }

    clearLastSearchAndItems() {
        this.props.setKeywords('');
        this.setState({ hasMoreItems: false, products: [] });
        this.props.history.push('/product-search/');
    }

    render() {

        return (
            <div>
                <h1>Item Search</h1>
                <Form>
                    <FormGroup
                        controlId="searchForm">
                        <ControlLabel>Enter a search term below.</ControlLabel>
                        <InputGroup>
                            <InputGroup.Button>
                                <Button onClick={this.clearLastSearchAndItems}>
                                    Clear
                                </Button>
                            </InputGroup.Button>
                            <FormControl
                                type="text"
                                placeholder={this.props.keywords === '' ? 'Search...' : this.props.keywords}
                                value={this.props.keywords || ''}
                                onChange={this.changeKeywords}
                                style={{ zIndex: 0 }}
                                onKeyDown={this.handleKeyDown.bind(this)}
                            />
                        </InputGroup>
                        <FormControl.Feedback />
                        <HelpBlock>Your search term must be at least 3 characters.</HelpBlock>
                    </FormGroup>
                </Form>

                <div id="item_search_loader" style={this.state.displayLoader === true ? {} : { display: 'none' }}>
                    <RingLoader
                        sizeUnit={"px"}
                        size={23}
                        color={'#4d721e'}
                    />
                </div>

                <InfiniteScroll
                    pageStart={0}
                    style={{ overflow: 'hidden' }} // ABSOLUTELY NECESSARY FOR DESKTOP VIEW
                    hasMore={this.state.hasMoreItems}
                    loadMore={this.loadItems}
                    loader={() => null}
                    threshold={this.state.mobileView === true ? 2000 : 500}
                >
                    <ProductBoxes productData={this.state.products} hasSearched={this.state.hasSearched} />
                </InfiniteScroll>
                <div style={this.state.foundItems === true && this.state.hasMoreItems === false ? {} : { display: 'none' }}>
                    <b style={{ color: "#cc0000" }}>Search finished.</b>
                </div>
                <div style={this.state.hasSearched === true && this.state.hasMoreItems === false && this.state.foundItems === false ? {} : { display: 'none' }}>
                    No items found.
                </div>
            </div>
        );
    }
}

export default connect(
    state => state.productSearch,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(ProductSearch);


// WEBPACK FOOTER //
// ./src/components/product/ProductSearch.js